import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../shared/utils/api.js'

export const fetchInterestedProperties = createAsyncThunk(
  'analytics/fetchInterestedProperties',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/interested/analytics/properties')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data.message || error.message)
    }
  }
)

export const fetchInterestedUser = createAsyncThunk(
  'analytics/fetchInterestedUser',
  async (userId, { rejectWithValue }) => {
    try {
      const endpoint = userId ? `/v1/interested/analytics/user/${userId}` : '/v1/interested/analytics/user'
      const response = await api.get(endpoint)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data.message || error.message)
    }
  }
)

export const fetchTrendingAnalytics = createAsyncThunk(
  'analytics/fetchTrendingAnalytics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/interested/analytics/trending')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data.message || error.message)
    }
  }
)

export const fetchMostViewedProperties = createAsyncThunk(
  'analytics/fetchMostViewedProperties',
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryString = new URLSearchParams(params).toString()
      const url = `/v1/properties/most-viewed${queryString ? `?${queryString}` : ''}`

      const response = await api.get(url)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchSavedProperties = createAsyncThunk(
  'analytics/fetchSavedProperties',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/bookings/admin/saved-properties')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchDislikedProperties = createAsyncThunk(
  'analytics/fetchDislikedProperties',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/properties/disliked')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchLikedProperties = createAsyncThunk(
  'analytics/fetchLikedProperties',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/properties/liked')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchMessageCount = createAsyncThunk(
  'analytics/fetchMessageCount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/messages/count')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchAdminTotalMessages = createAsyncThunk(
  'analytics/fetchAdminTotalMessages',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/total-messages')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchAdminSavedItems = createAsyncThunk(
  'analytics/fetchAdminSavedItems',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/saved-items')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchHourlyPropertyViews = createAsyncThunk(
  'analytics/fetchHourlyPropertyViews',
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryString = new URLSearchParams(params).toString()
      const url = `/v1/session/hourly-property-views${queryString ? `?${queryString}` : ''}`
      
      const response = await api.get(url)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchPlatformRatingStatistics = createAsyncThunk(
  'analytics/fetchPlatformRatingStatistics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/reviews/ratings/statistics/platform')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchCallVolume = createAsyncThunk(
  'analytics/fetchCallVolume',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/analytics/call-volume')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchMessageCountAnalytics = createAsyncThunk(
  'analytics/fetchMessageCountAnalytics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/analytics/message-count')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchSalesTrends = createAsyncThunk(
  'analytics/fetchSalesTrends',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/analytics/sales-trends')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchBookings = createAsyncThunk(
  'analytics/fetchBookings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/analytics/bookings')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchRatings = createAsyncThunk(
  'analytics/fetchRatings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/analytics/ratings')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchCommissionReturns = createAsyncThunk(
  'analytics/fetchCommissionReturns',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/analytics/commission-returns')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchTopBrokers = createAsyncThunk(
  'analytics/fetchTopBrokers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/agents/top-brokers')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchBrokers = createAsyncThunk(
  'analytics/fetchBrokers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/brokers')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchTeamMembers = createAsyncThunk(
  'analytics/fetchTeamMembers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/team/members')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchMostViewedPropertiesAgent = createAsyncThunk(
  'analytics/fetchMostViewedPropertiesAgent',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/properties/most-viewed')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchReviewCounts = createAsyncThunk(
  'analytics/fetchReviewCounts',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/reviews/counts')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchFilterSearches = createAsyncThunk(
  'analytics/fetchFilterSearches',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/analytics/filter-searches')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchTotalAppDownloads = createAsyncThunk(
  'analytics/fetchTotalAppDownloads',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/dashboard/kpi/total-app-downloads')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)